<template>
    <aside class="is-faqs">
        <div class="faqs-overlay" @click="hideUserSettings"></div>
        <div class="faqs-wrapper">


            <h2>Einstellungen</h2>


<!--            <div class="field">
                <label class="label">REISEN ANZEIGEN VON</label>
                <div class="control">
                    <organisation-select v-model="organisations"/>
                </div>
            </div>-->
            <div class="field">
                <label class="label">MAILBOX</label>
                <div class="control">
                    <email-select v-model="emailSelected" :save="false"></email-select>
                </div>
            </div>

            <div class="field">
                <label class="label">SCHECKBUCH</label>
                <div class="control">
                    <check-book-select v-model="checkBook"></check-book-select>
                </div>
            </div>

            <div class="field">
                <label class="label">AKTIVE NUTZER</label>
                <div class="control">
                    <toggle-switch v-model="allUsers">
                        <option :value="false">nur aktive User anzeigen</option>
                        <option :value="true">alle User anzeigen</option>
                    </toggle-switch>
                </div>
            </div>

            <div class="field">
                <label class="label">Alle Emails durchsuchen</label>
                <div class="control">
                    <toggle-switch v-model="allUserEmails">
                        <option :value="false">nur eigene Emails durchsuchen</option>
                        <option :value="true">alle Emails durchsuchen</option>
                    </toggle-switch>
                </div>
            </div>
            <div class="field is-ai-access">
                <label class="label">KI-ZUGANG</label>
                <p class="help">Persönliches Token für Codex und Claude. Damit arbeitet die KI als du — Bearbeiter, Historie und Absender stimmen automatisch.</p>

                <div v-for="token in activeAiTokens" :key="token.id" class="is-ai-token">
                    <div>
                        <strong>{{ token.label }}</strong>
                        <small>erstellt {{ formatDate(token.createdAt) }} · zuletzt benutzt {{ token.lastUsedAt ? formatDate(token.lastUsedAt) : 'nie' }} · <template v-if="token.expired">abgelaufen {{ formatDate(token.expiresAt) }}</template><template v-else>gültig bis {{ token.expiresAt ? formatDate(token.expiresAt) : 'unbegrenzt' }}</template></small>
                    </div>
                    <button class="button is-small" v-on:click="revokeAiToken(token)">Widerrufen</button>
                </div>

                <div v-if="newAiToken" class="is-ai-token-new">
                    <div class="is-ai-token-value">
                        <code>{{ newAiToken }}</code>
                        <i class="material-icons is-pointer" v-on:click="copy(newAiToken, 'Token kopiert!')">content_copy</i>
                    </div>
                    <p class="help">Wird nur jetzt angezeigt — kopieren und ins Setup-Skript einfügen.</p>
                </div>

                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input class="input" type="text" v-model="aiTokenLabel" placeholder="z. B. Codex Laptop">
                    </div>
                    <div class="control">
                        <button class="button is-primary" v-bind:class="{ 'is-loading': aiTokenLoading }" v-on:click="createAiToken">KI-Token erzeugen</button>
                    </div>
                </div>
            </div>

            <div class="field is-grouped buttons is-grouped-right">
                <button v-if="!isLoading" class="button is-large is-cancel" v-on:click="hideUserSettings">Abbrechen</button>
                <button class="button is-primary is-large" v-bind:disabled="!isDisabled" v-bind:class="{ 'is-loading' : isLoading }" v-on:click="save">Speichern</button>
            </div>
        </div>

    </aside>
</template>

<script>

import ToggleSwitch from '@components/form/ToggleSwitch';
import Accordion from '@components/Accordion';
import  Multiselect from '@components/form/Multiselect';
import  OrganisationSelect from '@components/form/OrganisationSelect';
import {editUser, getAiTokens, createAiToken as apiCreateAiToken, revokeAiToken as apiRevokeAiToken} from '@api';
import { currentUser, copy } from '@utilities/functions';
import moment from 'moment';
import { getSession, setSession } from '@utilities/session';
import {notifyError, notifySuccess} from "@components/Notification";
import EmailSelect from "@components/form/EmailSelect";
import CheckBookSelect from "@components/form/CheckBookSelect";



export default {
    data: function() {
        return {
            organisations: currentUser('organisations') ? currentUser('organisations') : [],
            currentOrganisation: currentUser('currentOrganisation'),
            isLoading: false,
            checkBook: localStorage.getItem('user') && localStorage.getItem('user').checkBook ? localStorage.getItem('user').checkBook : null,
            allUsers: null,
            allUserEmails: false,
            aiTokens: [],
            aiTokenLabel: '',
            aiTokenLoading: false,
            newAiToken: null,
        }
    },

    computed: {
        activeAiTokens: function () {
            return this.aiTokens.filter(token => !token.revokedAt);
        },
        isDisabled: function() {
            return this.currentOrganisation;
/*
            return this.currentOrganisation && this.organisations && this.organisations.length > 0;
*/
        },
        emailSelected: {
            get: function() {
                return currentUser('userEmails').find(email => email.organisation === '/api/organisations/' + this.currentOrganisation.id);
            },
            set: function(email) {
                this.currentOrganisation = currentUser('organisations').find(orga => '/api/organisations/' + orga.id === email.organisation);
            }
        },

    },

    methods: {
        copy,
        formatDate: function (date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        loadAiTokens: function () {
            getAiTokens().then(response => this.aiTokens = response.data);
        },
        createAiToken: function () {
            this.aiTokenLoading = true;
            apiCreateAiToken(this.aiTokenLabel).then(response => {
                this.newAiToken = response.data.token;
                this.aiTokenLabel = '';
                this.loadAiTokens();
            }, () => {
                notifyError('Das KI-Token konnte nicht erzeugt werden!');
            }).then(() => this.aiTokenLoading = false);
        },
        revokeAiToken: function (token) {
            if (!confirm(`KI-Token „${token.label}“ widerrufen? Die KI auf diesem Gerät ist danach nicht mehr als du angemeldet.`)) {
                return;
            }
            apiRevokeAiToken(token.id).then(() => {
                notifySuccess('Das KI-Token wurde widerrufen.');
                this.newAiToken = null;
                this.loadAiTokens();
            }, () => {
                notifyError('Das KI-Token konnte nicht widerrufen werden!');
            });
        },
        hideUserSettings: function() {
            this.$layout.toggleUserSettings(false)
        },
        save: function () {
            this.isLoading = true;

            editUser({
                id: currentUser('id'),
                data: {
                    organisations: this.organisations.map(orga => { return '/api/organisations/' + orga.id}),
                    currentOrganisation: '/api/organisations/' + this.currentOrganisation.id,
                    settings : {
                        showAllUsers: this.allUsers,
                        searchOtherUserEmails: this.allUserEmails,
                        fillBCC: currentUser('settings') ? currentUser('settings')['fillBCC'] : null
                    }
                },
            }).then(response => {
                notifySuccess('Die Einstellungen wurden aktualisiert!');
                const user = getSession();
                user.user.organisations = this.organisations;
                user.user.currentOrganisation = this.currentOrganisation;
                if(!user.user.settings) {
                    user.user.settings = [];
                }
                user.user.settings['showAllUsers'] = this.allUsers;
                user.user.settings['searchOtherUserEmails'] = this.allUserEmails;
                setSession(user);
                this.hideUserSettings();
            }, error => {
                notifyError("Die Einstellungen konnten nicht aktualisiert werden!")
            }).then(() => this.isLoading = false )

        }
    },

    mounted () {
        this.loadAiTokens();
        this.allUsers = currentUser('settings') ? currentUser('settings')['showAllUsers'] : false;
        this.allUserEmails = currentUser('settings') && currentUser('settings')['searchOtherUserEmails'] && currentUser('settings')['searchOtherUserEmails'] !== null ? currentUser('settings')['searchOtherUserEmails'] : false;
    },

    components: {
        CheckBookSelect,
        EmailSelect,
        Accordion,
        OrganisationSelect,
        Multiselect,
        ToggleSwitch
    }
}
</script>
